var React = require('react');

function CheckboxChecked14x14 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1.5","width":"12","height":"12","rx":"2","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"fill":"currentColor","d":"M4 4.5h6v6H4z","key":1})]);
}

CheckboxChecked14x14.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = CheckboxChecked14x14;

CheckboxChecked14x14.default = CheckboxChecked14x14;
